var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("支付方式？")]),_c('div',{staticClass:"content-info"},[_c('p',{staticClass:"txt1"},[_vm._v("在线支付")])])])
}]

export { render, staticRenderFns }